import Airports, {
  getServerSideProps as hgetServerSideProps,
} from '@pages/myapp/airports';
import { GetServerSideProps } from 'next';

export const getServerSideProps: GetServerSideProps = hgetServerSideProps;

export default Airports;
